import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_LOGIN_SETTINGS);

const _pk_name = "id";

const state = {
    data: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    editMode: false,
    record: {}
};

const getters = {
    editMode: (state) => {
        return state.editMode;
    },
    record: (state) => {
        return state.record;
    }
}

const mutations = {
    set: (state, [payload, le_id]) => {
        if (le_id) {
            state.data[le_id] = payload;
            state.data = {...state.data }
        }
    },
    clear: (state, le_id) => {
        state.data[le_id] = []
    },
    addEntity: (state, [payload, id]) => {
        if (!state.data[id]) {
            state.data[id] = [payload]
        } else {
            state.data[id].push(payload);
        }
    },

    updateEntityById: (state, [payload, le_id]) => {
        for (let i = 0; i < state.data[le_id].length; i++) {
            if (state.data[le_id][i][_pk_name] === payload.id) {
                state.data[le_id].splice(i, 1, payload);
            }
        }
    },

    removeEntityById: (state, [payload, le_id]) => {
        for (let i = 0; i < state.data[le_id].length; i++) {
            if (state.data[le_id][i][_pk_name] == payload) {
                state.data[le_id].splice(i, 1);
            }
        }
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },

    setEditMode: (state, payload) => {
        state.editMode = payload.editMode;
        state.record = payload.record;
    }

}

const actions = {
    async fetchAll({ commit }, le_id) {
        if (le_id) {
            try {
                commit("setFetching", true);
                let res = await axios_instance.get('', {
                    params: { le_id: le_id }
                });
                commit("setFetching", false);
                return res;
            } catch (error) {
                throw errorHandler(error.response);
            }
        }
    },
    async create({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.post('/', payload);
            commit("setSaving", false);
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async update({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.put('/' + payload.id, { data: payload });
            commit("setSaving", false);
            if (res.status == 200) {
                //commit("updateEntityById", [res.data, payload.le_id]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },


    async delete({ commit }, [payload, le_id]) {
        try {
            commit("setDeleting", true);
            let res = await axios_instance.delete(`/${payload.id}`);
            commit("setDeleting", false);
            if (res.status == 200) {
                commit("removeEntityById", [payload.id, le_id]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },


    async changeEditMode({ commit }, payload) {
        try {
            commit("setEditMode", payload);
        } catch (error) {
            throw errorHandler(error.response);
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}